import React, { useEffect, useState } from 'react';
import Style from '../../comps/css/BlogPortal.module.css';
import LargText from '../../../../components/text/LargText';
import { PiList } from 'react-icons/pi';
import BlogPage from '../BlogPage/BlogPage';
import basedGetUrlRequestLogedIn from '../../../../util/apiRequests/basedGetUrlRequestLogedIn';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import MainBlogPage from '../MainBlogPage/MainBlogPage';

const BlogPortal = ({ handleTogleMenu }) => {
  const [reqWasMaded, setReqWasMaded] = useState(false);
  const [storyData, setStoryData] = useState({});

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const category = queryParams.get('category');
  const id = queryParams.get('id');

  useEffect(() => {
    setReqWasMaded(false);
    basedGetUrlRequestLogedIn(
      `/api/blog-story-by-id/search?${category ? 'category=' + category : ''}${
        id ? '&id=' + id : ''
      }`
    )
      .then(res => {
        console.log(res.story)
        if (res.story) setStoryData(res.story);
        if (res.topReadStories) setTopReadStories(res.topReadStories);
        if (res) setReqWasMaded(true);
        if (res.topNewestStories) setTopNewestStories(res.topNewestStories);
      })
      .catch(() => {
        setReqWasMaded(true);
      });
  }, [search]);
  console.log('storyData:', storyData);

  return id ? <BlogPage PublishedStory={storyData} reqWasMaded={reqWasMaded} /> : <MainBlogPage />;
};

export default BlogPortal;
